import React from "react";
import get from "lodash/get";
import { object, number } from "prop-types";
import { Link } from "@quintype/components";

import Headline from "../../atoms/headline";
import CardImage from "../../atoms/card-image";
import PlaceholderImage from "../../atoms/placeholder-image";

import "./card-image-type-7.m.css";

const CardImageType7 = ({ story, headlineLimit }) => {
  const slug = story["hero-image-s3-key"];
  const storyImageSlug = get(story, ["alternative", "home", "default", "hero-image", "hero-image-s3-key"], slug);
  return (
    <Link href={`/${story.slug}`}>
      <div styleName="wrapper" className="card-image-type-2">
        {storyImageSlug ? (
          <CardImage story={story} widths={[85, 170]} defaultWidth={36} aspectRatio={[1, 1]} imageType="image1x1" />
        ) : (
          <PlaceholderImage story={story} />
        )}
        <Headline story={story} headerType={16} headerLevel={2} headlineLimit={headlineLimit} />
      </div>
    </Link>
  );
};

export default CardImageType7;

CardImageType7.propTypes = {
  story: object,
  headlineLimit: number
};
